import { defineStore } from "pinia";
import { useGeneralStore } from "%/stores/general-store";

export const useNotificationPreferenceStore = defineStore("notification-preference-store", {
  state: () => ({
    notificationPreferences: {},
    originalNotificationPreferences: {},
    loadingUpdateNotificationPreferences: false,
    loadingResetNotificationPreferences: false,
  }),
  getters: {
    apiUrl() {
      return useGeneralStore().links.api;
    },
  },
  actions: {
    getPreferencesByConversationId(conversationId) {
      return this.notificationPreferences[`conversation_id-${conversationId}`];
    },
    fetchDefaultNotificationPreferences() {
      this.apiGet(`${this.apiUrl}/notification/preferences`, {}, response => {
        this.notificationPreferences = {
          ...this.notificationPreferences,
          ...JSON.parse(JSON.stringify(response.preferences)),
        };

        this.originalNotificationPreferences = JSON.parse(JSON.stringify(this.notificationPreferences));
      });
    },
    fetchConversationNotificationPreferences(conversationId) {
      this.apiGet(`${this.apiUrl}/notification/conversation/${conversationId}/preferences`, {}, response => {
        this.notificationPreferences = {
          ...this.notificationPreferences,
          [`conversation_id-${conversationId}`]: JSON.parse(JSON.stringify(response.preferences)),
        };
        this.originalNotificationPreferences = JSON.parse(JSON.stringify(this.notificationPreferences));
      });
    },
    resetNotificationPreferences() {
      this.notificationPreferences = JSON.parse(JSON.stringify(this.originalNotificationPreferences));
    },
    resetConversationPreferencesToDefault(conversationId) {
      this.loadingResetNotificationPreferences = true;
      this.apiPost(`${this.apiUrl}/notification/conversation/${conversationId}/preferences/reset`, {}, () => {
        this.notificationPreferences[`conversation_id-${conversationId}`] = JSON.parse(JSON.stringify(
          this.notificationPreferences.default,
        ));
        this.originalNotificationPreferences = JSON.parse(JSON.stringify(this.notificationPreferences));
        this.loadingResetNotificationPreferences = false;
      }, () => {
        this.loadingResetNotificationPreferences = false;
      });
    },
    updateDefaultNotificationPreferences(successCallback) {
      this.loadingUpdateNotificationPreferences = true;
      this.apiPost(`${this.apiUrl}/notification/preferences`, {
        default: this.notificationPreferences.default,
      }, response => {
        successCallback(response);
        this.originalNotificationPreferences = JSON.parse(JSON.stringify(this.notificationPreferences));
        this.loadingUpdateNotificationPreferences = false;
      }, () => {
        this.loadingUpdateNotificationPreferences = false;
      });
    },
    updateConversationNotificationPreferences(conversationId, successCallback) {
      this.loadingUpdateNotificationPreferences = true;
      this.apiPost(`${this.apiUrl}/notification/conversation/${conversationId}/preferences`, {
        preferences: this.getPreferencesByConversationId(conversationId),
      }, response => {
        successCallback(response);
        this.originalNotificationPreferences = JSON.parse(JSON.stringify(this.notificationPreferences));
        this.loadingUpdateNotificationPreferences = false;
      }, () => {
        this.loadingUpdateNotificationPreferences = false;
      });
    },
  },
});
